<template>
  <card-flex v-if="showAsCard"
             close-message
             mobile-wrapper-column
             :icon-green="true"
             :icon="getStepText(cardStepId, 'cardFlex.icon')">
    <div v-html="getStepText(cardStepId, 'cardFlex.title')
      || getStepText(cardStepId, 'title')"></div>
    <el-button slot="after"
               v-if="actualStep > 0"
               class="button-procedures"
               @click="$router.push({
                path: getStepText(cardStepId, 'cardFlex.buttonLinkPath') || '/procedures'})">
      {{ getStepText(cardStepId, 'cardFlex.button')
      || getTextVersion('procedures.cardFlex.button') }}
    </el-button>
  </card-flex>
  <el-collapse v-else
               class="procedures-content__collapse"
               v-model="activeCollapse">
    <div :class="['procedures-content__collapse__content',
    actualStep === index && '--border-active' || actualStep > index && '--border-valid']"
         v-for="(step, index) in steps"
         v-bind:key="step.id">
      <div class="procedures-content__collapse__content__indicator">
        <nxt-indicator :before="false"
                       style-icon="fas"
                       :current-index="actualStep"
                       :index="index"
                       :nb="actualStep <= index &&  index + 1"
                       :check="!customIcon && actualStep > index">
          <font-awesome-icon v-if="customIcon" :icon="['fas', customIcon]"
            class="icon"
            size="xs"></font-awesome-icon>
        </nxt-indicator>
      </div>
      <el-collapse-item :title="stepTitle || (step && getStepText(step.id, 'title'))"
                        :disabled="actualStep < index"
                        :name="index">
        <component v-if="actualStep >= index"
                   :actual-step="actualStep"
                   :step="index"
                   :signed-offer="isSigned && currentOffer"
                   :stepTextPath="step.id"
                   :is="`step${step.number}`"
                   :is-minarm="isMinarm" >
        </component>
      </el-collapse-item>
    </div>
  </el-collapse>
</template>

<script>
import { mapGetters } from 'vuex';
import offersHelper from '@/utils/helpers/offers';
import CardFlex from '@/utils/components/CardFlex.vue';
import ContentPage from '@/components/layout/ContentPage.vue';
import Indicator from '@nextories/vue-core-components/src/components/atoms/Indicator.vue';
import ProgressBar from '@nextories/vue-core-components/src/components/atoms/ProgressBar.vue';
import Step1 from '@/components/procedures/prebookStepper/steps/Step1.vue';
import Step2 from '@/components/procedures/prebookStepper/steps/Step2.vue';
import Step3 from '@/components/procedures/prebookStepper/steps/Step3.vue';
import Step4 from '@/components/procedures/prebookStepper/steps/Step4.vue';
import MoveManager from '@/utils/components/MoveManager.vue';

export default {
  name: 'proceduresContent',
  extends: MoveManager,
  components: {
    CardFlex,
    ContentPage,
    Indicator,
    ProgressBar,
    Step1,
    Step2,
    Step3,
    Step4,
  },
  props: {
    displayOnlyCurrentStep: {
      type: Boolean,
      default: false,
    },
    showAsCard: {
      type: Boolean,
      default: false,
    },
    stepTitle: String,
    customIcon: String,
    openCurrentStep: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      activeCollapse: [0],
      actualStep: 0,
      stepsBase: [
        { id: 'first', number: 1 },
        { id: 'second', number: 2 },
        { id: 'third', number: 3 },
        { id: 'fourth', number: 4 },
      ],
      steps: [],
    };
  },
  computed: {
    ...mapGetters({
      demandStore: 'demandStore/demand',
      offersStore: 'offerStore/offers',
      projectSelected: 'projectStore/projectSelected',
    }),
    // 1 REP_PREBOOKED
    isSecondState() {
      if (this.isIndividual) {
        return !this.isInitialState;
      }
      return !!this.offersStore.find((offer) => offersHelper.isValidationStatus(offer));
    },
    isInitialState() {
      return offersHelper.isInitialState(
        this.offersStore,
        this.projectSelected.params.prebooked,
      );
    },
    // REP_VALID_FOR_PCD || REP_SUCCESS || REP_OPTION || REP_MER_DGR || REP_SUPERVISION
    isThirdState() {
      return !!this.validOffer;
    },
    // (REP_SUCCESS || REP_OPTION || REP_MER_DGR || REP_SUPERVISION) && signed
    isLastState() {
      return !!offersHelper.isFinished(this.offersStore);
    },
    cardStepId() {
      if (offersHelper.needsNewSignature(this.offersStore)) {
        return 'reSign';
      }
      return this.steps[0].id;
    },
  },
  methods: {
    getState() {
      if (this.isLastState) {
        return 3;
      }
      if (this.isThirdState) {
        return 2;
      }
      if (this.isSecondState) {
        return 1;
      }
      return 0;
    },
    getStepText(step, textKey) {
      if (this.showAsCard && this.actualStep === 0 && !this.isInitialState) {
        textKey += 'Waiting';
      }
      const params = {
        offerId: this.validOffer && this.validOffer.id,
        signPath: offersHelper.needsFirstSignature(this.offersStore)
          ? 'signature'
          : 'resume',
      };
      const minarmPath = `procedures.minarmSteps.${step}.${textKey}`;
      if (this.isMinarm && this.$te(minarmPath)) {
        return this.getTextVersion(minarmPath, params);
      }
      const courtagePath = `procedures.courtageSteps.${step}.${textKey}`;
      if (!this.isCommissionaire && this.$te(courtagePath)) {
        return this.getTextVersion(courtagePath, params);
      }
      return this.getTextVersion(`procedures.steps.${step}.${textKey}`, params);
    },
  },
  watch: {
    offersStore: {
      handler() {
        this.actualStep = this.getState();
        this.steps = this.stepsBase;
        this.activeCollapse = this.openCurrentStep ? [this.actualStep] : [];
        if (this.displayOnlyCurrentStep || this.showAsCard) {
          this.steps = [this.stepsBase[this.actualStep]];
          this.activeCollapse = this.openCurrentStep ? [0] : [];
        }
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.procedures-content {
  &__collapse {
    &__content {
      display: flex;
      border-left: solid 5px $--color-santas-gray;
      &.--border-valid {
        border-color: $--color-primary;
      }
      &.--border-active {
        border-color: $--color-secondary;
      }
      &__indicator {
        height: 60px;
        display: grid;
        margin: {
          right: 20px;
          left: 20px;
        }
        :deep(.indicator) {
          margin: auto;
        }
      }
    }
    :deep(.el-collapse) {
      &-item {
        flex: 1;
        font-family: "futura-pt", "Helvetica Neue", Helvetica, sans-serif;
        &__content {
          font-size: 15px;
        }
        &__header {
          min-height: 60px;
          line-height: 20px;
          font-size: 15px;
          font-weight: bold;
        }
      }
    }
  }
  :deep(.card-flex) {
    &__after {
      flex: 1;
      width: 100%;
      margin-left: 0;
    }
    &__content {
      flex: inherit;
      margin: unset;
    }
    &__wrapper {
      align-items: inherit;
      min-height: 350px;
    }
  }
  &__title {
    margin-top: 20px;
    margin-left: 20px;
    @include breakpoint(tablet) {
      margin-left: 0;
    }
    &--white {
      color: $--color-white;
    }
    &--white {
      color: $--color-white;
    }
  }
  &__body {
    position: relative;
    margin: 20px 0;
    &__collapse {
      border: none;
    }
    &__card {
      border-radius: 0;
      background-color: $--color-light-grey;
      @include breakpoint(tablet) {
        border-radius: 4px;
      }
    }
    &__empty {
      margin: 0;
      font-style: italic;
      &__card {
        border-radius: 0;
        @include breakpoint(tablet) {
          border-radius: 4px;
        }
      }
    }
  }
}
</style>
